import { render } from "./BuyerOneColumnPage.vue?vue&type=template&id=c96ef6d0&scoped=true"
import script from "./BuyerOneColumnPage.vue?vue&type=script&lang=js"
export * from "./BuyerOneColumnPage.vue?vue&type=script&lang=js"

import "./BuyerOneColumnPage.vue?vue&type=style&index=0&id=c96ef6d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96ef6d0"]])

export default __exports__